module.exports = __webpack_public_path__ + "img/time.6b7ad5ec.svg";